<template>
  <div class="sales">
    <div class="sales-top">
      <div class="sales-top__name">商品销量</div>
      <div class="sales-top-fun">
        <div class="sales-top-item">
          <el-select size="mini" placeholder="全部国家"></el-select>
        </div>
        <div class="sales-top-item">
          <el-select size="mini" placeholder="全部店铺"></el-select>
        </div>
        <div class="sales-top-item sales-top-item--input">
          <el-input size="mini" placeholder="请输入ASIN,SKU,店铺名称,产品名称或其他"></el-input>
        </div>
        <div class="sales-top__btn">查询</div>
      </div>
    </div>
    <div class="sales-table">
      <Table :head="SalesTableHead" width="1654" height="550"></Table>
    </div>
  </div>
</template>

<script>
import { SalesSearchData, SalesNewModule } from './class'
import Table from 'components/common/Table.vue'
export default {
  name: 'productSales',
  components: {
    Table
  },
  data(){
    return {
      /**搜索数据 */
      searchData: new SalesSearchData(),
      /**商品销量表头 */
      SalesTableHead: SalesNewModule.NEWTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.sales{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-size: 16px;
      font-weight: bold;
      color: black;
    }
    &-fun{
      display: flex;
      align-items: center;
    }
    &-item{
      display: flex;
      align-items: center;
      // width: 120px;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 120px;
        }
        .el-input{
          width: 120px;
        }
      }
      &__name{
        border: 1px solid #cecece;
        width: 90px;
        height: 28px;
        line-height: 28px;
        text-align: center;
      }
      &--input{
        ::v-deep{
          .el-input__inner{
            width: 300px;
          }
          .el-input{
            width: 300px;
          }
        }
      }

    }
    &__btn{
      line-height: 30px;
      padding: 0 30px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
